module.exports = __webpack_public_path__ + "img/consulta.e4ec282d.png";